import { render, staticRenderFns } from "./PremiumMeeting.vue?vue&type=template&id=88f4cfae&"
import script from "./PremiumMeeting.vue?vue&type=script&lang=js&"
export * from "./PremiumMeeting.vue?vue&type=script&lang=js&"
import style0 from "./PremiumMeeting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports